import { API_URL } from 'utils/constants/app';
import { RequestHelper } from 'utils/helpers/RequestHelper';

const userServiceUrl = `${API_URL}/user`;

const getUserInfo = () => RequestHelper.GET(`${userServiceUrl}/userInfo`);

const getDetailsFromAccount = (laboratoryId) => RequestHelper.GET(`${userServiceUrl}/${laboratoryId}/personContactDetailsRecid`);

const postBugReport = data => RequestHelper.POST(`${userServiceUrl}/bugreport`, data);

const removeImpersonation = () => RequestHelper.POST(`${userServiceUrl}/removeImpersonation`, {});

const setImpersonation = id => RequestHelper.POST(`${userServiceUrl}/setImpersonation/${id}`, {});

const getLaboUsers = laboratoryId => RequestHelper.GET(`${userServiceUrl}/users/${laboratoryId}`);

const getLaboUsersForImpersonation = laboratoryId => RequestHelper.GET(`${userServiceUrl}/users/${laboratoryId}/impersonation`);

const getLaboUserDetailedInfo = (personContactDetailsId) => RequestHelper.GET(`${userServiceUrl}/${personContactDetailsId}/details`);

const createLaboUser = (userDetailedInfo) => RequestHelper.POST(
  `${userServiceUrl}`, userDetailedInfo
);

const updateLaboUserDetailedInfo = (personContactDetailsId, userDetailedInfo) => RequestHelper.POST(
  `${userServiceUrl}/${personContactDetailsId}/details`,
  userDetailedInfo
);

const getUserStatusesNames = () => RequestHelper.GET(`${userServiceUrl}/availableStatuses`);

const getUserRolesNames = (laboOnly) => RequestHelper.GET(`${userServiceUrl}/availableRoles`);

const getUserCivilitiesNames = () => RequestHelper.GET(`${userServiceUrl}/availableCivilities`);

const searchUsersWithFiltersForAdminEcc = (contactGridFilterView, signal) => RequestHelper.POST(`${userServiceUrl}/searchUsersWithFiltersForAdminEcc`,
  contactGridFilterView, { signal });

const searchUsersWithFilters = (contactGridFilterView, signal) => RequestHelper.POST(`${userServiceUrl}/searchUsersWithFilters`,
  contactGridFilterView, { signal });

const getLaboUsersWithProgramResponsibilities = laboratoryId => RequestHelper.GET(`${userServiceUrl}/users/${laboratoryId}/programs`);

const modifyUsersResponsibilities = (laboratoryId, data) => RequestHelper.POST(`${userServiceUrl}/users/${laboratoryId}/modifyPrograms`, data);

export const UserService = {
  getUserInfo,
  getLaboUserDetailedInfo,
  createLaboUser,
  updateLaboUserDetailedInfo,
  postBugReport,
  removeImpersonation,
  setImpersonation,
  getLaboUsers,
  getLaboUsersForImpersonation,
  getUserStatusesNames,
  getUserRolesNames,
  getUserCivilitiesNames,
  searchUsersWithFiltersForAdminEcc,
  searchUsersWithFilters,
  getLaboUsersWithProgramResponsibilities,
  modifyUsersResponsibilities,
  getDetailsFromAccount
};